const questions = [
  {
    question: 'Sensor {id} not pinging?',
    answers: ['yes', 'no', 'maybe']
  },
  {
    question: 'Base station {id} not pinging?',
    answers: ['yes', 'no', 'maybe']
  },
  {
    question: 'Average data quality at farm {id} is low?',
    answers: ['yes', 'no', 'maybe']
  },
  {
    question: 'Average data quality for sensor {id} is low?',
    answers: ['yes', 'no', 'maybe']
  },
  {
    question: 'Field access point {id} has a very high load?',
    answers: ['yes', 'no', 'maybe']
  },
  {
    question: 'Average latency between fap {id} and bs {id} is high?',
    answers: ['yes', 'no', 'maybe']
  },
  {
    question: 'Sensor {id} has very low signal strength?',
    answers: ['yes', 'no', 'maybe']
  },
  {
    question: 'Fap {id} is not pinging to bs {id}?',
    answers: ['yes', 'no', 'maybe']
  },
  {
    question: 'All base stations not pinging?',
    answers: ['yes', 'no', 'maybe']
  },
  {
    question: 'All farms have low data quality?',
    answers: ['yes', 'no', 'maybe']
  }
]

export default questions
